import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import { FETCH_ORGANIZATION_BY_ID } from '../actions/getOrganizationById';
import { FETCH_ORGANIZATION_LOGO } from '../actions/fetchOrganizationLogo';
import { GET_LOGIN_ORGANIZATION_DETAILS } from '../actions/getLoginOrganizationDetails';
import { FETCH_ORGANIZATIONS } from '../actions/fetchOrganizations';
import {
  SELECT_ORGANIZATION_TOKEN,
  RESET_ORGANIZATION_TOKEN,
  UPDATE_ORGANIZATION_SELECTION_ERROR,
  RESET_ORGANIZATION_SELECTION_ERROR,
} from '../actions/organizationSelection';
import { CHANGE_ORGANIZATION_LOGO } from '../actions/changeOrganizationLogo';
import { FETCH_SITE_LOGO } from '../actions/getSiteLogo';
import { TOS_NEED_APPROVE } from '../actions/termsOfService';

const defaultState = {
  status: requestsStatuses.default,
  hasError: false,
  selectedOrganizationToken: null,
  selectedOrganizationHasTermsAndConditions: false,
  selectedOrganizationPatientLoginMethod: 'INTERNAL',
  reCaptchaSiteKey: '',
  organizationStatus: requestsStatuses.default,
  organizationLogo: '',
  organizationLogoLabels: [],
  siteLogo: '',
  siteLogoLabels: [],
  organizationStoreLink: '',
  organizationsList: [],
  loginConfig: {},
};

export default createReducer(defaultState, {
  [FETCH_ORGANIZATIONS.failure]: (state) => ({
    ...state,
    status: requestsStatuses.failure,
    hasError: true,
    organizationsList: [],
    selectedOrganizationToken: defaultState.selectedOrganizationToken,
    organizationLogo: '',
    organizationLogoLabels: [],
  }),
  [FETCH_ORGANIZATIONS.pending]: (state) => ({
    ...state,
    status: requestsStatuses.pending,
    hasError: false,
    organizationsList: [],
  }),
  [FETCH_ORGANIZATIONS.success]: (state, { payload: { organizationsList } }) => ({
    ...state,
    status: requestsStatuses.success,
    hasError: false,
    organizationsList,
  }),

  [GET_LOGIN_ORGANIZATION_DETAILS.failure]: (state) => ({
    ...state,
    fetchTermsAndConditionsStatus: requestsStatuses.failure,
  }),
  [GET_LOGIN_ORGANIZATION_DETAILS.pending]: (state) => ({
    ...state,
    fetchTermsAndConditionsStatus: requestsStatuses.pending,
  }),
  [GET_LOGIN_ORGANIZATION_DETAILS.success]: (state, { payload: {
    hasTermsAndConditions,
    patientLoginMethod,
    reCaptchaSiteKey,
    organizationStoreLink,
    loginConfig,
  } }) => ({
    ...state,
    fetchTermsAndConditionsStatus: requestsStatuses.success,
    selectedOrganizationHasTermsAndConditions: hasTermsAndConditions,
    selectedOrganizationPatientLoginMethod: patientLoginMethod,
    reCaptchaSiteKey,
    organizationStoreLink,
    loginConfig,
  }),

  [SELECT_ORGANIZATION_TOKEN]: (state, { payload: { selectedOrganizationToken } }) => ({
    ...state,
    selectedOrganizationToken,
  }),

  [RESET_ORGANIZATION_TOKEN]: (state) => ({
    ...state,
    selectedOrganizationToken: defaultState.selectedOrganizationToken,
    organizationLogo: '',
    organizationLogoLabels: [],
  }),

  [UPDATE_ORGANIZATION_SELECTION_ERROR]: (state, { meta: { hasError } }) => ({
    ...state,
    hasError,
  }),

  [RESET_ORGANIZATION_SELECTION_ERROR]: (state) => ({
    ...state,
    hasError: false,
  }),

  [CHANGE_ORGANIZATION_LOGO]: (state, { payload: { organizationLogo, organizationLogoLabels } }) => ({
    ...state,
    organizationLogo,
    organizationLogoLabels,
  }),

  [FETCH_SITE_LOGO.success]: (state, { payload: { siteLogo, logoLabels } }) => ({
    ...state,
    siteLogo,
    siteLogoLabels: logoLabels,
  }),

  [FETCH_ORGANIZATION_BY_ID.success]: (state, { payload: { organizationStoreLink } }) => ({
    ...state,
    organizationStoreLink,
    organizationStatus: requestsStatuses.success,
  }),

  [FETCH_ORGANIZATION_BY_ID.pending]: (state) => ({
    ...state,
    organizationStatus: requestsStatuses.pending,
  }),

  [FETCH_ORGANIZATION_LOGO.success]: (state, { payload: { logo, logoLabels } }) => ({
    ...state,
    organizationLogo: logo,
    organizationLogoLabels: logoLabels,
  }),

  [FETCH_ORGANIZATION_LOGO.pending]: (state) => ({
    ...state,
  }),

  [TOS_NEED_APPROVE]: (state, { payload: { orgId } }) => ({
    ...state,
    selectedOrganizationToken: orgId || state.selectedOrganizationToken,
  }),

});
